// 定义全局变量
/* eslint-disable */
export default {
	adminHost: [
		{"name":"Nooie国内后台", "host":"chn.nooie.com"},
		{"name":"Nooie国外后台", "host":"power123.nooie.com"},
		{"name":"Nooie全球后台", "host":"brain.nooie.com"},
		{"name":"NooieHome国内后台", "host":"homecn.nooie.com"},
		{"name":"NooieHome国外后台", "host":"homeus.nooie.com"},
		{"name":"NooieHome全球后台", "host":"nooiehome.nooie.com"}
	]
}



// WEBPACK FOOTER //
// ./src/global/attribute.js